import { update, init } from "./State.fs.js";
import { view } from "./View.fs.js";
import { PageHeader } from "../../../../Bfs.Web.Portale/Types.fs.js";
import { singleton, tail, head, isEmpty } from "../../../fable_modules/fable-library-js.4.19.0/List.js";
import { Page } from "./Types.fs.js";
import { WebPart$3 } from "../../../../Bfs.Web.Portale/WebPart.fs.js";

export const Part = new WebPart$3(init, update, view, (model_1) => (new PageHeader(1, ["Einstellungen"])), (_arg_2) => (!isEmpty(_arg_2) ? ((head(_arg_2) === "settings") ? (isEmpty(tail(_arg_2)) ? (new Page()) : undefined) : undefined) : undefined), (_arg_1) => singleton("settings"), (_arg) => {
    if (_arg.tag === 7) {
        return _arg.fields[0];
    }
    else {
        return undefined;
    }
});

//# sourceMappingURL=WebPart.fs.js.map
